import Route from "../../../router/Route";
import { RouterView } from "vue-router";

import Overview from "../pages/Overview.vue";

export default new Route(
	"environment",
	"/environment",
	RouterView,
	[
		new Route(
			"environment.index",
			"",
			Overview,
			[
				new Route(
					"environment.generalSettings",
					"general-settings",
					() => import("@/modules/environment/components/GeneralTab.vue"),
					[]
				),
				new Route(
					"environment.authentication",
					"authentication",
					() =>
						import("@/modules/environment/components/AuthenticationTab.vue"),
					[],
					{ permissions: ["can_manage_explorer"] }
				),
				new Route(
					"environment.presetFilters",
					"preset-filters",
					() => import("@/modules/environment/components/PresetFilters.vue"),
					[],
					{ permissions: ["can_manage_explorer"] }
				),
				new Route(
					"environment.permissions",
					"permissions",
					() => import("@/modules/environment/components/PermissionTab.vue"),
					[]
				),
				new Route(
					"environment.notificationEvents",
					"notification-events",
					() =>
						import("@/modules/environment/components/NotificationEvents.vue"),
					[]
				),
				new Route(
					"environment.legacyMysql",
					"legacy-mysql-server",
					() => import("@/modules/environment/components/LegacyMysql.vue"),
					[]
				),
				new Route(
					"environment.clickhouse-server",
					"clickhouse-server",
					() =>
						import("@/modules/environment/components/ClickhouseServerTab.vue"),
					[
						new Route(
							"environment.clickhouse-server.edit",
							":uuid",
							() =>
								import(
									"@/modules/environment/components/ClickhouseServerEditTab.vue"
								),
							[]
						),
					]
				),
				new Route(
					"environment.booking-experts",
					"booking-experts",
					() => import("@/modules/environment/components/BookingExperts.vue"),
					[],
					{ permissions: ["can_manage_booking_experts"] }
				),
				new Route(
					"environment.colorPalettes",
					"color-palettes",
					() => import("@/ui/components/colorPalette/ColorPalettesTab.vue"),
					[],
					{},
					"",
					[],
					{ scope: "global" }
				),
				new Route(
					"environment.colorPalettes.edit",
					"color-palettes/:palette_uuid",
					() => import("@/ui/components/colorPalette/ColorPaletteEdit.vue"),
					[],
					{},
					"",
					[],
					{ scope: "global" }
				),
				new Route(
					"environment.ai-prompts",
					"ai-prompts",
					() => import("@/modules/environment/components/AiPromptsTab.vue"),
					[]
				),
			],
			{},
			"/environment/general-settings"
		),
	],
	{ permissions: ["can_manage_environment"] }
);
